import React, { Component } from "react";
import { connect } from "react-redux";
import QR from "qrcode.react";
import Measure from "react-measure";

import { Translate } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";

import evio_o from "../../../../styles/images/evio_o.svg";

class QRCode extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      size: 0,
    };

    this.setCanvasSize = this.setCanvasSize.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }
  componentWillUnmount() {
    this._mounted = false;
  }

  setCanvasSize(bounds) {
    const { width, height } = bounds;
    const size = Math.min(width, height);
    if (this.state.size !== size) this.safeSetState({ size });
  }

  reset() {
    this.safeSetState({ size: 0 });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const imageSettings = {
      ...(this.props.brand?.brandName === "EVIO" && {
        imageSettings: {
          src: evio_o,
          width: this.state.size * 0.1026,
          height: this.state.size * 0.1026,
          x: this.state.size * 0.1158,
          y: this.state.size * 0.1158,
        },
      }),
    };

    return (
      <Modal
        id="qrCode"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.reset}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: 700 }}>
            <Translate value="accountDetails_QRcode" />
          </Modal.Title>
        </Modal.Header>
        <Measure bounds onResize={contentRect => this.setCanvasSize(contentRect.bounds)}>
          {({ measureRef }) => (
            <Modal.Body ref={measureRef}>
              <QR
                value={this.props.prefix + this.props.phone}
                size={this.state.size}
                bgColor="transparent"
                fgColor="#353841"
                {...imageSettings}
              />
            </Modal.Body>
          )}
        </Measure>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  prefix: state.account.accountData.internationalPrefix,
  phone: state.account.accountData.phone,
  brand: state.app.brand,
});

export default connect(mapStateToProps, null)(QRCode);
